import { render, staticRenderFns } from "./yuewelfare.vue?vue&type=template&id=efbc96c2&scoped=true&"
import script from "./yuewelfare.vue?vue&type=script&lang=js&"
export * from "./yuewelfare.vue?vue&type=script&lang=js&"
import style0 from "./yuewelfare.vue?vue&type=style&index=0&id=efbc96c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbc96c2",
  null
  
)

export default component.exports